var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('OrdersFBATableContent',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams},on:{"resetFilter":_vm.resetFilter,"changeFilter":_vm.changeFilter,"showMore":_vm.showMore,"reload":_vm.reload,"downloadFiles":_vm.downloadFiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }